/**
 * Starts Sentry error monitoring as a side effect of being imported.
 *
 * `main.tsx` imports this first — before the styles and the app — so errors
 * thrown while any later module evaluates, or during the first render, are
 * reported too. A no-op when VITE_SENTRY_DSN is unset.
 */

import { initSentry } from "@/lib/sentry";

initSentry();
